/*
* @Author: LiuMouLiang
* @Date:   2021-08-17 15:22:03
* 复制移动端代码
*/
import {
    _for,
    _getDate,
    _findName,
    _filter,
    _cloneObj,
    _isValue,
    _formatDate,
    typeOf,
    getObjVal,
    setObjVal,
    findTarget,
    getIdCardInfo,
} from 'tools';
import {
    getJobTypeVal,
    useStateErrorMsg,
    globalControlConfig,
    trace,
} from '_libs/util';

// 获取年龄限制根据职业类别
export const getAgeRestrictByJobType = function(ageRestrictData, jobType){
    if(typeOf(ageRestrictData) !== 'array') return;
    for(let i = 0; i < ageRestrictData.length; i++){
        const item = ageRestrictData[i] || {};
        if(item.jobTypes && jobType && item.jobTypes.includes(jobType)){
            return item;
        }
    }
};

// 身份证号计算年龄
function getAgeByIdCard(idCard, validStartDate) {
    let myDate = validStartDate ? _getDate(validStartDate) : new Date();
    let month = myDate.getMonth() + 1;
    let day = myDate.getDate();
    let age_y = + idCard.substring(6, 10);
    let age = myDate.getFullYear() - age_y - 1;
    if (+(idCard.substring(10, 12)) < month || +(idCard.substring(10, 12)) == month && +(idCard.substring(12, 14)) <= day) {
        age++;
    };
    return age;
}


// 校验年龄限制根据职业类别 === insuredIdType===1
export const checkAgeRestrictByJobType = function({
    ageRestrictData,
    person,
    validStartDate,
}){
    if(typeOf(ageRestrictData) !== 'array' || typeOf(person) !== 'object') return '';
    const insuredIdType = getObjVal(person, 'insuredIdType') || getObjVal(person, 'cardType');
    const occupationType = getObjVal(person, 'occupationType');
    const ageCheckType = getObjVal(globalControlConfig, 'frontControlInfo.ageCheckType');
    let errMsg = '';
    if(insuredIdType == 1 && occupationType && ageRestrictData) {
        const insuredIdNo = getObjVal(person, 'insuredIdNo') || getObjVal(person, 'idCardNo');
        if(insuredIdNo){
            // const idCardInfo = getIdCardInfo(insuredIdNo);
            const ageRestrict = getAgeRestrictByJobType(ageRestrictData, occupationType);
            let idCardAge;
            // ageRestrict.maxAge = 30;
            //当前时间点
            if(ageCheckType === 'orderCreateDay') {
                idCardAge = getAgeByIdCard(insuredIdNo);
            }else if(validStartDate){ //投保起期
                idCardAge = getAgeByIdCard(insuredIdNo, validStartDate);
            };

            // trace('职业类别年龄校验 == ', idCardAge, ageRestrict, person, validStartDate)
            if(idCardAge && ageRestrict) {
                const {
                    minAge,
                    maxAge
                } = ageRestrict;
                if(idCardAge > maxAge || idCardAge < minAge) {
                    const insuredName = getObjVal(person, 'insuredName') || getObjVal(person, 'name') || '';
                    errMsg = `被保人${insuredName}年龄不符合承保范围: ${minAge}-${maxAge}岁`;
                    trace('=== 职业类别年龄校验 == ', idCardAge, _formatDate(validStartDate))
                }
            }
        }
    };
    return errMsg;
};



// WEBPACK FOOTER //
// ./src/util/insure-unit.js